import { getUserContentPreferences, updateUserContentPreferences } from "@/services/api/User";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";

const useContentPreferences = () => {
  const [preferences, setPreferences] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    fetchPreferences();
  }, []);

  const fetchPreferences = async function () {
    try {
      const response = await getUserContentPreferences();
      setPreferences((response.data.data || []).map((item) => item.uuid));
    } catch (error) {
      console.log("Error", error);
      toast.error("Error to load user preferences!");
    } finally {
      setLoading(false);
    }
  };

  const updatePreferences = async function () {
    setIsUpdating(true);

    try {
      const response = await updateUserContentPreferences({
        user_preferences: preferences,
      });

      return response.data;
    } catch (error) {
      throw error;
    } finally {
      setIsUpdating(false);
    }
  };

  const toggleUserPreference = function (contentUuid) {
    let selected = [...preferences];
    if (selected.includes(contentUuid)) {
      selected = selected.filter((uuid) => uuid !== contentUuid);
    } else {
      selected.push(contentUuid);
    }

    setPreferences(selected);
  };

  const selectAll = (contentTypes) => {
    let selected = [...preferences];
    contentTypes.forEach((contentType) => {
      if (selected.includes(contentType.uuid)) return;
      selected.push(contentType.uuid);
    });

    setPreferences(selected);
  };

  return {
    fetchPreferences,
    preferences,
    updatePreferences,
    toggleUserPreference,
    isLoading,
    isUpdating,
    selectAll,
  };
};

export { useContentPreferences };
